import React from "react";
// nodejs library that concatenates classes
import styles from "assets/jss/material-kit-pro-react/views/ecommerceStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import { Link } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

class FooterLinks extends React.Component {


  render() {
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12} sm={4} md={4}>
          <h5>About Us</h5>
          <p>
            Kinos is one of the Spain leading commercial and residential real estate advisory firms.
WE ARE PROUD OF OUR SPANISH ORIGINS.{" "}
          </p>
          <p>
            We provide a fully integrated platform of services to family businnes, national and multinational corporations and institutional investors across the globe,
            as well as to occupiers, owners and developers of real estate on a local, regional and national level..{" "}
          </p>
          <a href="https://twitter.com/kinosgroup?lang=en" className={classes.dropdownLink}>
            <i className="fab fa-twitter" />{" "}
          </a>
          <a href="https://www.facebook.com/Kinosgroup/" className={classes.dropdownLink}>
          <i className="fab fa-facebook-square" />{" "}
          </a>
          <a href="https://www.youtube.com/channel/UCakBgiVXW6jUQ7Dw5WiiDKw?feature=embeds_subscribe_title" className={classes.dropdownLink}>
          <i className="fab fa-youtube" />{" "}
          </a>
          <a href="https://www.instagram.com/KinosGroup/" className={classes.dropdownLink}>
          <i className="fab fa-instagram" />{" "}
          </a>
        </GridItem>

        <GridItem xs={12} sm={4} md={4}>

          <h5>Market with Kinos</h5>
          <div className={classes.socialFeed}>
            <div>
              <Link to="/market" className={classes.dropdownLink}>
                 <p>Register Offer</p>
              </Link>
            </div>
            <div>
            <Link to="/market" className={classes.dropdownLink}>
               <p>Register Demand</p>
            </Link>
            </div>

          </div>



          <h5>Properties</h5>
          <div className={classes.socialFeed}>
            <div>
            <a href="http://kinosgroup.com/hotels" className={classes.dropdownLink}>
               <p>Hotels</p>
            </a>
            </div>
            <div>
            <a href="http://kinosgroup.com/malls" className={classes.dropdownLink}>
               <p>Shopping Centers & Malls</p>
            </a>
            </div>
            <div>
            <Link to="/retail" className={classes.dropdownLink}>
               <p>Retail</p>
            </Link>
            </div>
            <div>
            <a href="http://kinosgroup.com/industrial" className={classes.dropdownLink}>
               <p>Industrial</p>
            </a>
            </div>
            <div>
            <a href="http://kinosgroup.com/offices" className={classes.dropdownLink}>
               <p>Offices</p>
            </a>
            </div>
            <div>
            <a href="http://kinosgroup.com/residential" className={classes.dropdownLink}>
               <p>Residential</p>
            </a>
            </div>
            <div>
            <a href="http://kinosgroup.com/new_development_properties" className={classes.dropdownLink}>
               <p>New Developments</p>
            </a>
            </div>
            <div>
            <a href="http://kinosgroup.com/rural_lands" className={classes.dropdownLink}>
               <p>Rural Lands</p>
            </a>
            </div>
            <div>
            <a href="http://kinosgroup.com/urban_lands" className={classes.dropdownLink}>
               <p>Urban Lands</p>
            </a>
            </div>
            <div>
            <a href="http://kinosgroup.com/buildings" className={classes.dropdownLink}>
               <p>Buildings</p>
            </a>
            </div>
            <div>
            <a href="http://kinosgroup.com/investments" className={classes.dropdownLink}>
               <p>Investments</p>
            </a>
            </div>
            <div>
            <a href="http://kinosgroup.com/offer" className={classes.dropdownLink}>
               <p>Investments Opportunities</p>
            </a>
            </div>
          </div>

        </GridItem>

        <GridItem xs={12} sm={4} md={4}>

          <h5>Markets</h5>
          <div className={classes.socialFeed}>
            <div>
            <Link to="/demand" className={classes.dropdownLink}>
               <p>Demands</p>
            </Link>
            </div>
            <div>
            <Link to="/offer" className={classes.dropdownLink}>
               <p>Offers</p>
            </Link>
            </div>
          </div>

          <h5>Areas</h5>
          <div className={classes.socialFeed}>
            <div>
              <Link to="/brokers" className={classes.dropdownLink}>
                 <p>For Brokers</p>
              </Link>
            </div>
            <div>
              <Link to="/developers" className={classes.dropdownLink}>
                 <p>For Developers</p>
              </Link>
            </div>
            <div>
              <Link to="/investors" className={classes.dropdownLink}>
                 <p>For Investors</p>
              </Link>
            </div>
            <div>
              <Link to="/relations" className={classes.dropdownLink}>
                 <p>For Relations</p>
              </Link>
            </div>
          </div>

          <h5>Services</h5>
          <div className={classes.socialFeed}>
            <div>
              <Link to="/buying-selling" className={classes.dropdownLink}>
                 <p>Buying or Selling Brokerage</p>
              </Link>
            </div>
            <div>
              <Link to="/new-developments" className={classes.dropdownLink}>
                 <p>New Developments Marketing and sales</p>
              </Link>
            </div>
            <div>
              <Link to="/assets-management" className={classes.dropdownLink}>
                 <p>Assets Management</p>
              </Link>
            </div>
            <div>
              <Link to="/familly-office" className={classes.dropdownLink}>
                 <p>Family Office Services</p>
              </Link>
            </div>
            <div>
              <Link to="/finance" className={classes.dropdownLink}>
                 <p>Finance</p>
              </Link>
            </div>
            <div>
              <Link to="/investment-services" className={classes.dropdownLink}>
                 <p>Investment</p>
              </Link>
            </div>
            <div>
              <Link to="/research" className={classes.dropdownLink}>
                 <p>Research</p>
              </Link>
            </div>
            <div>
              <Link to="/valuation" className={classes.dropdownLink}>
                 <p>Valuation</p>
              </Link>
            </div>
            <div>
              <Link to="/development" className={classes.dropdownLink}>
                 <p>Development</p>
              </Link>
            </div>

          </div>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(styles)(FooterLinks);
